module.exports = __webpack_public_path__ + "static/img/2bg_25.5657e33.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/2bg_25.png
// module id = 681
// module chunks = 1